import { cloneDeep } from 'lodash-es';
import { EMPTY_CUSTOMER } from '@nx-ng/constants';
import { ICustomerDetails, ICustomerDetailsPage } from '@nx-ng/types';
import { Customer, MarketingPreference } from '../client/src';
import { utcToZonedTime } from 'date-fns-tz';
import { DEFAULT_TIMEZONE } from '@nx-ng/constants/timezone';

export const formatCustomerDetails = (
  customer?: Customer
): ICustomerDetails => {
  const newCustomer: Customer = customer
    ? cloneDeep({ ...customer })
    : EMPTY_CUSTOMER;

  return {
    id: customer?.id,
    firstName: newCustomer?.firstName || '',
    lastName: newCustomer?.lastName || '',
    telephoneNumber: newCustomer?.telephoneNumber,
    address: {
      address1: newCustomer?.address?.address1 || '',
      address2: newCustomer?.address?.address2 || '',
      town: newCustomer?.address?.town || '',
      postCode: newCustomer?.address?.postCode || '',
    },
    dateOfBirth: newCustomer?.dateOfBirth
      ? utcToZonedTime(new Date(newCustomer.dateOfBirth), DEFAULT_TIMEZONE)
      : undefined,
  };
};

export const formatCustomerPageDetails = (
  customer: Customer | undefined
): ICustomerDetailsPage | undefined => {
  if (!customer) {
    return undefined;
  }
  const newCustomer: ICustomerDetails = formatCustomerDetails(customer);

  return {
    customerDetails: {
      ...newCustomer,
    },

    preferences: {
      keepInTouch: customer.marketingPreferences
        ? customer?.marketingPreferences?.some(
            (preference: MarketingPreference) => preference.optIn
          )
        : false,
    },
  };
};
